import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d256629e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = { class: "DialogSection D-Flex" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "F-Bold" }
const _hoisted_7 = { class: "F-Bold" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_9 = ["Key"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"height":"2em"},
  class: "W-100"
}, null, -1))
const _hoisted_11 = { class: "DialogSection W-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: 'CookiesDialog_' + _ctx.DialogIndex,
    class: "CookiesDialogdBody"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DialogData.Data?.AvailableItems, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass([_ctx.Selected(item) > -1 ? 'Disabled' : '', "ItemsMiniGridSelector"]),
              onClick: ($event: any) => (_ctx.Select(item)),
              key: item.ID
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.DialogData.Data?.Item.BrandName), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.DialogData.Data?.Item.CategoryName), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.DialogData.Data?.Item.Name), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.DialogData.Data?.Item.Code), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.Details), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(item.Quantity), 1),
              _hoisted_8,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DialogData.Data.Item.Specifications, (spec) => {
                return (_openBlock(), _createElementBlock("span", { Key: spec }, [
                  _createElementVNode("span", null, _toDisplayString(spec.Name), 1),
                  _createElementVNode("span", null, _toDisplayString(spec.Description), 1)
                ], 8, _hoisted_9))
              }), 256))
            ], 10, _hoisted_5))
          }), 128))
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
            class: "CookiesButtons F1_5em BG4"
          }, _toDisplayString(_ctx.Translate('Back')), 1)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}